  
  export interface PaginationInfoProps {
  currentPage: number;
  totalItems: number;
  totalPages: number;
  label:string;
}
  
  export const PaginationInfo = (pagination:PaginationInfoProps) => {
   
    return (
      <div className="text-sm text-muted-foreground">
        Page {pagination.currentPage} of {pagination.totalPages} ({pagination.totalItems}{" "}
        total {pagination.label})
      </div>
    );
  };